export const BASE_URL = 'https://vulners.com' as const;

export const FALLBACK_POSTS = [
    {
        link: '/blog/archive_v4/',
        title: 'New and Improved Archive API: Faster, Cleaner, and More Efficient Data Retrieval',
        description:
            "Vulners' enhanced Archive API: Streamlined access to enriched data. Faster downloads, clearer timestamps, simpler structures, optimized pricing.",
        tags: [],
        date: '27 May 2025',
        published: '2025-05-27T00:00:00.000Z',
        image: '/blog/assets/img/archive_v4.png',
        timeToRead: '4 min. read'
    },

    {
        link: '/blog/audit-api-new-version/',
        title: 'New Vulners Audit and CPE Search API',
        description:
            'With the release of the new version of Vulners API, we are pleased to introduce several new features and enhancements that aim to improve the accuracy and reliability of our vulnerability detection capabilities.',
        tags: ['cpe', 'audit', 'api'],
        date: '24 February 2025',
        published: '2025-02-24T00:00:00.000Z',
        image: '/blog/assets/img/audit_api.png',
        timeToRead: '8 min. read'
    },

    {
        link: '/blog/softwareapi-new-version/',
        title: 'New Version of Vulners CVE Search API',
        description:
            'Almost 32,800 CVE published in 2024 highlight the need for automated vulnerability searches. Vulners new search API offers precise, fast results with data from NVD, Vulnrichment, and CNA for better vulnerability management.',
        tags: [],
        date: '4 November 2024',
        published: '2024-11-04T00:00:00.000Z',
        image: '/blog/assets/img/search_api.png',
        timeToRead: '10 min. read'
    }
] as const;
